module.exports = __webpack_public_path__ + "static/media/ussd-paiement.1c369c26.svg";